module.exports = __webpack_public_path__ + "static/big-tooth-8249f341048fff54db5164a172f39110.png";